module.exports = __webpack_public_path__ + "static/img/indexICON72.85780ee6.png";